import { startTransition } from 'react';
import { connect } from 'react-redux';

import { RootState } from 'reducers';

import { makeGetProject } from 'selectors/projects';
import { makeGetFetchedState, makeGetLoadingState } from 'selectors/global';

import { fetchTaskGroups } from 'actions/task-groups';

interface TaskGroupsFetcherProps {
    hasActiveProject: boolean,
    projectId: string,
    taskGroupsFetched: boolean,
    taskGroupsLoading: boolean
}

const TaskGroupsFetcher = ({ hasActiveProject, projectId, taskGroupsFetched, taskGroupsLoading }: TaskGroupsFetcherProps) => {
    startTransition(() => {
        if (hasActiveProject && projectId && !taskGroupsFetched && !taskGroupsLoading) {
            fetchTaskGroups(projectId);
        }
    });

    return null;
}

const makeMapStateToProps = () => {
    const getTaskGroupsFetched = makeGetFetchedState();
    const getTaskGroupsLoading = makeGetLoadingState();
    const getProject = makeGetProject();

    return ({ projects, taskGroups }: any, ownProps: { projectId: string }) => {
        const project = getProject(projects.items, ownProps.projectId);

        return {
            hasActiveProject: Boolean(project?.id && !project.removed && !project.archived && !project.error),
            taskGroupsFetched: getTaskGroupsFetched(taskGroups.fetchInfo, 'project', ownProps.projectId),
            taskGroupsLoading: getTaskGroupsLoading(taskGroups.fetchInfo, 'project', ownProps.projectId),
        }
    };
}

export default connect(makeMapStateToProps)(TaskGroupsFetcher);
